const translations = {
  cta: "See all events",
  heading: "Your event guide"
};

export default translations;
